import React, { useState } from 'react';
import { Card, Title, Col as TremorCol } from '@tremor/react';
import { IonGrid, IonRow, IonCol, IonButton, IonIcon, IonPopover, IonText } from '@ionic/react';
import { colorTheme } from '../../utils/constants';
import { informationCircle } from 'ionicons/icons';

const ArrearsOverview = ({ handleSendBalanceReminder, arrears, currency, onClick }) => {
    const [showArrearsToolTip, setShowArrearsToolTip] = useState(false);

    return (
        <TremorCol numColSpan={1} numColSpanLg={2}>
            <Card className="mb-3" style={{ height: "fit-content", borderRadius: "10px" }}>
                <div className="card-body">
                    <Title className="mb-2 text-center">
                        Arrears Overview
                        <IonIcon id="arrearsToolTip" icon={informationCircle} className="ml-2" onClick={() => setShowArrearsToolTip(true)} />
                    </Title>
                    <IonPopover
                        isOpen={showArrearsToolTip}
                        onDidDismiss={() => setShowArrearsToolTip(false)}
                    >
                        <IonText className="p-2">These are tenants who have arrears/balances not paid.</IonText>
                    </IonPopover>
                    <IonGrid>
                        <IonRow className="mt-2" style={{ fontWeight: 'bold' }}>
                            <IonCol size="0" sizeSm="2" sizeMd="2" sizeLg="2" className="d-none d-sm-block">Unit</IonCol>
                            <IonCol size="6" sizeSm="3" sizeMd="3" sizeLg="3">Name</IonCol>
                            <IonCol size="0" sizeSm="4" sizeMd="4" sizeLg="4" className="d-none d-sm-block">Amount</IonCol>
                            <IonCol size="6" sizeSm="3" sizeMd="3" sizeLg="3">Action</IonCol>
                        </IonRow>
                        {arrears && arrears.length > 0 && arrears.map((item) => (
                            <IonRow key={item.unit} className="mt-2 tenant-list-row" style={{ alignItems: "center", backgroundColor: colorTheme["primary"]["50"], color: "black" }}>
                                <IonCol size="0" sizeSm="2" sizeMd="2" sizeLg="2" className="d-none d-sm-block">{item.unit}</IonCol>
                                <IonCol size="6" sizeSm="3" sizeMd="3" sizeLg="3">{item.tenant}</IonCol>
                                <IonCol size="0" sizeSm="4" sizeMd="4" sizeLg="4" className="d-none d-sm-block">{item.amount.toLocaleString("en-US")} {currency}</IonCol>
                                <IonCol size="6" sizeSm="3" sizeMd="3" sizeLg="3">
                                    <IonButton
                                        onClick={() => handleSendBalanceReminder(item.tenantId)}
                                        className='mr-2'
                                        fill='outline'
                                        style={{
                                            borderRadius: "10px",
                                            height: "fit-content",
                                            width: 'min-content',
                                            minWidth: '100%'
                                        }}
                                    >
                                        Remind
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        ))}
                        <hr color='lightgray' />
                        <IonRow className="d-flex justify-content-end align-items-end mt-2">
                            <IonButton onClick={onClick} size={"lg"} fill="outline" color="primary">
                                View All Arrears <i className="fa fa-angle-right"></i>
                            </IonButton>
                        </IonRow>
                    </IonGrid>
                </div>
            </Card>
        </TremorCol>
    );
};

export default ArrearsOverview;
